import axios from 'axios'
import queryString from 'query-string'
import { PeopleContactsResponse } from 'src/models/people.models'
import { GetConnectionsRequest } from 'src/queries/connections/connections.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

/**
 * Pure network layer for GET /connections (the current user's contacts). No
 * React, no React Query, no Redux store imports — request config is pulled
 * through the one allowed `getRequestConfig` boundary (`RequestConfig.Default`
 * is the exact config the legacy `getUserConnections` thunk used via
 * `selectAuthedJsonApiRequestConfig`). Errors are normalized to the backend
 * error contract by `getResponseData`.
 *
 * The URL is built the same way as the legacy thunk
 * (`/connections?${queryString.stringify(params)}`) so an empty param object
 * still produces the trailing `?`, matching prior behavior byte-for-byte.
 */
export const getConnections = async (
  params: GetConnectionsRequest = {},
): Promise<PeopleContactsResponse> =>
  getResponseData(
    axios.get<PeopleContactsResponse>(
      `/connections?${queryString.stringify(params)}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
